module.exports = __webpack_public_path__ + "static/media/imagemUm.b36fa87f.jpg";